export default __webpack_public_path__ + "static/media/PhoneFull.a5962a54.png";